import styled from 'styled-components';

export const UserItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 79px;
    line-height: 21px;
    cursor: pointer;
`;

export const ProfileWrapper = styled.div`
    margin-right: 12px;
`;

export const UserItemWrapper = styled.div`
    display: flex;
    align-items: center;
    
`;

export const NameWrapper = styled.div`
    > label:first-child {
        margin-right: 4px;
    }

`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    label {
        pointer-events: none;
    }
`;

export const StatusWrapper = styled.div`
    > svg {
        margin-left: ${24 - 6.42}px;
    }
`;